<!--
 * @Description: 活跃结构
 * @Author:  单珊珊
 * @Date: 2022-02-15 09:33:21
 * @LastEditTime: 2022-07-06 17:21:37
 * @LastEditors:  
-->
<template>
  <div class="app">
    <div class="header">
      <div class="title-underline">活跃机构</div>
      <div class="right">赛道数据由<img :src="$store.state.static_img_url+'pic/logo.png'" @click="haddleApplyTry2(32)">提供支持</div>
    </div>
    <div class="track-content">
      <Spin fix v-if="loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>

      <div class="search">
        <img class="days" :src="$store.state.static_img_url+'pic/vcbeat/30days.png'">
        <div class="desc">{{ type == 1 ? '机构投资笔数统计' : '投资金额统计(RMB)'}}</div>
        <Dropdown @on-click="selectMenuY($event)" @on-visible-change="changeStatus($event)">
          <a href="javascript:void(0)">
            {{ type_text }}
            <i class="iconfont" v-if="status">&#xe73c;</i>
            <i class="iconfont" v-else>&#xe73d;</i>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem :id="1" :name="1" :selected="type == 1">事件数(起)</DropdownItem>
            <DropdownItem :id="2" :name="2" :selected="type == 2">融资额(千万)</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <ul class="agency-list">
        <li v-for="item, index in org_list" :key="index">
          <Tooltip content="查看机构详情" placement="top-start">
            <a  @click="toOrgDetail" :href="$store.state.index_path + '/orgDetail/' + item.uid" target="_blank">
              <div class="left">
                <p class="l1-ellipsis">{{ item.name }}</p>
                <!-- <a @click="toOrgDetail" :href="$store.state.index_path + '/orgDetail/' + item.uid" target="_blank">机构详情</a> -->
              </div>
              <div class="line" :style="{width: 'calc((100% - 150px)*'+item.eventCount/max + ')' }" v-if="type == 1"></div>
              <div class="line" :style="{width: 'calc((100% - 150px)*'+item.eventAmount/max + ')' }" v-else></div>
              <span class="num" v-if="type == 1">{{ item.eventCount }}</span>
              <span class="num" v-else>{{ item.eventAmount | amountFilter2 }}</span>
            </a>
          </Tooltip>
        </li>
      </ul>
      <button class="more-agency" @click="goToEventList">查看更多</button>
    </div>
  </div>
</template>
<script>
import { getActiveOrg } from '@/service.js'
export default {
  inject: ['haddleApplyTry2'],
  data() {
    return {
      type: 1,
      // type_text: '',
      org_list: [],
      max: 0,
      status: false,
      loading: true
    }
  },
  beforeMount() {
    this.getActiveOrg()
  },
  computed: {
    type_text() {
      return this.type == 1 ? '事件数(起)' : '融资额(千万)'
    },
  },
  methods: {
    //活跃机构
    async getActiveOrg() {
      this.loading = true
      let res = await getActiveOrg({ type: this.type }, (error) => {
        this.$Message.error('请求错误！')
      })
      this.loading = false
      if (res.code == 0) {
        this.org_list = res.data
        let arr = this.org_list.map((item, index) => {
          return this.type == 1 ? item.eventCount : item.eventAmount
        })
        this.max = Math.max(...arr)
      }
      
    },
    selectMenuY(val) {
      this.type = val
      this.getActiveOrg()
      let content = val == 2 ? '右侧活跃机构(切换融资额)' : '右侧活跃机构(切换事件数)'
      _czc.push(['_trackEvent', '看赛道(新)', content, '点击量'])
    },
    changeStatus(status) {
      this.status = status
    },
    toOrgDetail() {
      _czc.push(['_trackEvent', '看赛道(新)', '右侧活跃机构(机构详情)', '点击量'])
    },
    //跳转至融资事件列表页
    goToEventList() {
      const { href } = this.$router.resolve({ name: 'EventList' })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', '右侧活跃机构(查看更多)', '点击量'])
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common_track.stylus'
.track-content
  position relative
  >>> .ivu-spin-fix
    .ivu-spin-main
      top 50% !important
.header
  .right
    display flex
    align-items center
    font-size 12px
    font-family PingFang SC
    font-weight 500
    color #999999
    line-height 18px
    img
      height 16px
      margin 0 2px
.search
  display flex
  justify-content space-between
  align-items center
  font-family PingFang SC
  font-weight 500
  color #333333
  margin-top 20px
  .desc
    font-size 14px
  >>>.ivu-dropdown
    .ivu-dropdown-rel
      border 1px solid #E0E0E0
      height 26px
      a
        font-size 12px
        font-weight 500
        color #333333
        line-height 26px
        padding 6px 8px
        i
          font-size 12px
          color #FA5A00
ul
  display flex
  flex-direction column
  justify-content space-between
  li
    .ivu-tooltip
      width 100%
      margin-top 7px
      font-weight 500
      display flex
      align-items center
      flex-wrap wrap
      justify-content center
      height 42px
      cursor pointer
      transition all 0.5s
      &:hover
        background #FFFFFF
        box-shadow 0px 4px 10px 0px rgba(0,0,0,0.1000)
        padding-left 12px
        .left
          p
            color #FA5A00
      .left
        width 80px
        // padding-left 12px
        padding-right 15px
        p
          width 100%
          font-size 13px
          color #333333
          line-height 14px
        a
          display block
          margin-top 5px
          font-size 12px
          color #FA5A00
          position relative
          line-height 1
          -webkit-transition all 0.5s
          transition all 0.5s
          &:hover
            color #FF4800
          &::after
            border solid #FA5A00
            border-width 0 1px 1px 0
            display inline-block
            padding 2px
            transform rotate(-45deg)
            position absolute
            top 3px
            left 50px
            content ''
      .line
        height 12px
        background linear-gradient(90deg, #FA5A00, #FFC697)
        position relative
        transition all 0.5s
        &::after
          position absolute
          right -11px
          top 0
          content ''
          width 0
          height 0
          border-top 12px solid #FFC697
          border-right 12px solid transparent
      .num
        padding-left 20px
        width 70px
        display block
    .ivu-tooltip-rel
      a
        display flex
        align-items center
.more-agency
  width 100%
  height 37px
  margin-top 23px
  border 1px solid #FA5A00
  background none
  color #FA5A00
  font-size 14px
  cursor pointer
  &:hover
    color #FF4800
    border 1px solid #FF4800
</style>